import { AEMModelAssets } from './tracker/constants';
import { getCtaText } from './getCtaText';
import { CT_PERSONALIZATION_TYPES, CT_PERSONALIZATION_CTA_TEXT } from './constants';
import { getModelNameFromUrl } from './tracker/getModelNameFromUrl';

const ensureThreeTiles = (currentTiles, allTiles) => {
  // If we already have 3 or more tiles, return first 3
  if (currentTiles.length >= 3) {
    return currentTiles.slice(0, 3);
  }

  // Get default tiles that aren't already in currentTiles
  const defaultTiles = allTiles
    .filter((tile) => tile.isDefault === true)
    .filter((tile) => {
      const tileModelName = getModelNameFromUrl(tile.CTA?.href);
      return !currentTiles.some((ct) => {
        const ctModelName = getModelNameFromUrl(ct.CTA?.href);
        return ctModelName && tileModelName && ctModelName === tileModelName;
      });
    })
    .map((tile) => ({
      ...tile,
      tileType: CT_PERSONALIZATION_TYPES.mlp,
      CTA: {
        ...tile.CTA,
        text: `${CT_PERSONALIZATION_CTA_TEXT.mlp} ${tile.heading.text}`,
      },
    }));

  // Fill up to 3 tiles
  const tilesNeeded = 3 - currentTiles.length;
  return [...currentTiles, ...defaultTiles.slice(0, tilesNeeded)];
};

export const getFallbackTiles = ({ tiles, featuredTile }) => {
  const toReturn = tiles
    .filter((tile) => tile.isDefault === true)
    .map((tile) => ({
      ...tile,
      tileType: CT_PERSONALIZATION_TYPES.mlp,
      CTA: {
        ...tile.CTA,
        text: `${CT_PERSONALIZATION_CTA_TEXT.mlp} ${tile.heading.text}`,
      },
    }));

  // If featuredTile exists and is isEnabled, insert it as the first tile
  let finalTiles = toReturn.length === 0 ? tiles : toReturn;
  if (featuredTile && (featuredTile.isEnabled === undefined || featuredTile.isEnabled === true)) {
    // Check if featuredTile duplicates any default tile by URL
    const featuredTileModelName = getModelNameFromUrl(featuredTile.CTA?.href);
    const isDuplicate = finalTiles.some((tile) => {
      const tileModelName = getModelNameFromUrl(tile.CTA?.href);
      console.log('tileModelName', tileModelName, 'featuredTileModelName', featuredTileModelName);
      return tileModelName && featuredTileModelName === tileModelName;
    });

    // Only insert featuredTile if it's not a duplicate
    if (!isDuplicate) {
      finalTiles = [featuredTile, ...finalTiles.slice(0, 2)];
    }
  }

  // Ensure we always have exactly 3 tiles
  finalTiles = ensureThreeTiles(finalTiles, tiles);

  // NOTE: since this is the fallback tiles `isPersonalized === false`
  return {
    isPersonalized: false,
    tiles: finalTiles,
  };
};
export const getPersonalizedTiles = ({
  personalizedResults,
  tiles,
  personalizationData,
  debug,
  featuredTile,
}) => {
  const textNewBuild = 'Start a new build';
  const textResumeBuild = 'Continue your build';
  const textNonBuild = '';
  const subHeading = {
    text: '',
    variant: 'order3',
    htmlTag: 'p',
  };
  // START: For Content Authors to debug Tile Content
  if (debug && personalizationData) {
    // set all to true
    const { tiles: originalTiles } = personalizationData;
    if (debug === CT_PERSONALIZATION_TYPES.MLP) {
      // change cta
      // change href
      const tileData = originalTiles.map((tile) => {
        return {
          ...tile,
          isDefault: true,
          tileType: CT_PERSONALIZATION_TYPES.MLP,
          CTA: {
            ...tile.CTA,
            text: `Explore ${tile.heading.text.replace(/^Audi /, '')}`,
          },
        };
      });
      return {
        isPersonalized: true,
        tiles: ensureThreeTiles(tileData, tiles),
      };
    }
    if (
      debug === CT_PERSONALIZATION_TYPES.NEW_BUILD ||
      debug === CT_PERSONALIZATION_TYPES.RESUME_BUILD
    ) {
      // change cta
      // change href
      const tileData = originalTiles.map((tile) => {
        return {
          ...tile,
          isDefault: true,
          tileType: CT_PERSONALIZATION_TYPES.NEW_BUILD,
          subHeading: {
            ...subHeading,
            text: debug === CT_PERSONALIZATION_TYPES.NEW_BUILD ? textNewBuild : textResumeBuild,
          },
          CTA: {
            ...tile.CTA,
            text: `Build ${tile.heading.text.replace(/^Audi /, '')}`,
            href: `${tile.CTA.href}build/`,
          },
        };
      });
      return {
        isPersonalized: true,
        tiles: ensureThreeTiles(tileData, tiles),
      };
    }
  }
  // END: For Content Authors to debug Tile Content
  const tileData = personalizationData?.tiles || tiles;
  if (personalizedResults) {
    const modelNames = Object.keys(personalizedResults).splice(0, 3);
    const filteredTiles = tileData.filter((tile) => {
      return modelNames.includes(tile.heading.text);
    });

    if (filteredTiles.length > 0) {
      const modelNamesOfficialObj = Object.values(personalizedResults).splice(0, 3);
      let tileIndex = 0;
      const personalizedTiles = modelNamesOfficialObj
        .map((item) => {
          const tile = filteredTiles.find(
            (ct) => ct.heading.text === `Audi ${AEMModelAssets[item.modelName]}`,
          );
          if (tile) {
            const tileType = personalizedResults[`Audi ${AEMModelAssets[item.modelName]}`].type;
            const ctaText = getCtaText(tileType, `${AEMModelAssets[item.modelName]}`);
            let { href } = tile.CTA;
            let textSubheading = '';
            if (tileType === CT_PERSONALIZATION_TYPES.RESUME_BUILD) {
              href = personalizedResults[`Audi ${AEMModelAssets[item.modelName]}`].url;
              textSubheading = textResumeBuild;
            }
            if (tileType === CT_PERSONALIZATION_TYPES.NEW_BUILD) {
              href = `${tile.CTA.href}build/`;
              textSubheading = textNewBuild;
            }

            if (tileIndex !== 0) {
              textSubheading = textNonBuild;
            }
            tileIndex += 1;
            return {
              ...tile,
              tileType,
              subHeading: {
                ...subHeading,
                text: textSubheading,
              },
              CTA: {
                ...tile.CTA,
                text: ctaText,
                href,
              },
            };
          }
          return undefined;
        })
        .filter((tile) => tile !== undefined);

      // If featuredTile exists and is isEnabled, replace the secondary tile (index 1) with it
      let finalTiles = personalizedTiles;
      if (
        featuredTile &&
        (featuredTile.isEnabled === undefined || featuredTile.isEnabled === true) &&
        personalizedTiles.length >= 1
      ) {
        // Check if featuredTile duplicates any personalized tile by URL
        const featuredTileModelName = getModelNameFromUrl(featuredTile.CTA?.href);
        const isDuplicate = personalizedTiles.some((tile) => {
          const tileModelName = getModelNameFromUrl(tile.CTA?.href);
          return tileModelName && featuredTileModelName === tileModelName;
        });

        // Only insert featuredTile if it's not a duplicate
        if (!isDuplicate) {
          if (personalizedTiles.length === 1) {
            // Need to fill remaining slots with default tiles to reach 3 total
            const defaultTiles = tileData
              .filter((tile) => tile.isDefault === true)
              .filter(
                (tile) => !personalizedTiles.find((pt) => pt.heading.text === tile.heading.text),
              )
              .map((tile) => ({
                ...tile,
                tileType: CT_PERSONALIZATION_TYPES.mlp,
                CTA: {
                  ...tile.CTA,
                  text: `${CT_PERSONALIZATION_CTA_TEXT.mlp} ${tile.heading.text}`,
                },
              }));
            finalTiles = [personalizedTiles[0], featuredTile, ...defaultTiles.slice(0, 1)];
          } else {
            finalTiles = [personalizedTiles[0], featuredTile, ...personalizedTiles.slice(2)];
          }
        }
      }

      // Ensure we always have exactly 3 tiles
      finalTiles = ensureThreeTiles(finalTiles, tileData);

      const toReturn = {
        isPersonalized: true,
        tiles: finalTiles,
      };
      return toReturn;
    }
    return getFallbackTiles({ tiles: tileData, featuredTile });
  }

  return getFallbackTiles({ tiles: tileData, featuredTile });
};
